export default __webpack_public_path__ + "media/src/features/my-activity/assets/ratingIconFilled-010bd77f8dc3b3ffd4280ae2a8786a67.svg";